import { Component } from '@angular/core';

@Component({
  selector: 'app-connect-device',
  templateUrl: './connect-device.component.html',
  styleUrls: ['./connect-device.component.scss']
})
export class ConnectDeviceComponent {

}
